<template>
  <!-- Always open mode - no toggle buttons -->
  <div v-if="alwaysOpen" class="text-center">
    <div class="h-full border">
      <div class="" :style="{ height: autoHeight ? 'auto' : '500px', overflow: 'auto'  }">
        <AgGridVue
          :key="tableKey"
          :theme="standardListTheme"
          style="width: 100%; height: 100%"
          :column-defs="computedColumnDefs"
          :row-data="rowData"
          :default-col-def="defaultColDef"
          :group-display-type="groupDisplayType"
          :grid-options="gridOptions"
          :loading="loading"
          @grid-ready="onGridReady"
        />
      </div>
    </div>
  </div>
  <!-- Toggle mode -->
  <div v-else-if="table_open" class="text-center">
    <button class="bg-black font-semibold rounded text-white text-xs px-2 py-1 mb-2" @click="table_open=false">Close {{table_button_text}}</button>
    <div class="h-full border">
      <div class="" :style="{ height: autoHeight ? 'auto' : '500px', overflow: 'auto'  }">
        <AgGridVue
          :key="tableKey"
          :theme="standardListTheme"
          style="width: 100%; height: 100%"
          :column-defs="computedColumnDefs"
          :row-data="rowData"
          :default-col-def="defaultColDef"
          :group-display-type="groupDisplayType"
          :grid-options="gridOptions"
          :loading="loading"
          @grid-ready="onGridReady"
        />
      </div>
    </div>
  </div>
  <div v-else class="text-center">
    <button class="bg-black font-semibold rounded text-white text-xs px-2 py-1" @click="table_open=true">Open {{table_button_text}}</button>
  </div>

</template>

<script>
import { AgGridVue } from 'ag-grid-vue3'
import {standardListTheme} from '@/utils/common';

export default {
  components: {
    AgGridVue,
  },
  props: {
    table_button_text: {
      type: String,
      default: 'Table View'
    },
    rowData: {
      type: Array,
      required: true
    },
    column_defs: {
      type: Array,
      required: false
    },
    autoHeight: {
      type: Boolean,
      required: false,
      default: false
    },
    alwaysOpen: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  data() {
    return {
      table_open:false,
      gridApi: null,
      gridOptions: {
        suppressAggFuncInHeader: true,
        domLayout: this.autoHeight ? 'autoHeight' : null,
      },
      loading: true,
      groupDisplayType: 'singleColumn',
      defaultColDef: {
        flex: 1,
        sortable: true,
        filter: true,
        resizable: true,
        wrapText: true,
        autoHeight: true,
        cellClass:'cell-theme-left-aligned'
      },
      tableKey: 0,
      isOpenDeleteEngagementModal: false,
      deleteEngagementId: null,
    }
  },
  computed: {
    standardListTheme() {
      return standardListTheme
    },
    computedColumnDefs() {
      if (this.column_defs?.length) {
        return this.column_defs
      }
      else {
        if (!this.rowData.length) {
          return []
        }
        const keys = Object.keys(this.rowData[0])
        return keys.map((key, index) => ({
          field: key,
          headerName: this.toProperCase(key.replace(/_/g, ' ')),
          hide: index >= 5 && key !== 'object_id' && key !== 'engagement_user_name'
        }))
      }
    },
  },
  methods: {
    toProperCase(str) {
      return str.replace(/\b\w/g, char => char.toUpperCase())
    },
    async onGridReady(params) {
      this.gridApi = params.api
      params.api.sizeColumnsToFit()
      window.addEventListener('resize', this.onWindowResize)
      this.loading = false
    },
    onWindowResize() {
      if (this.gridApi) {
        this.gridApi.sizeColumnsToFit()
      }
    },
  },
  watch: {
    rowData: {
      handler() {
        this.tableKey++
      },
      deep: true,
    },
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.onWindowResize)
  }
}
</script>

<style scoped>
/* Add any necessary styles here */
</style>
